import { Spinner } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { ClientSideMenu } from '../../../features/ClientSideMenu';
import { StressAssessmentScheduleNotificationBanner } from '../../../features/StressAssessmentScheduleNotificationBanner';
import { StressAssessmentUserResult } from '../../../features/StressAssessmentUserResult';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  const { id: stressAssessmentId, user_id: userId } = useParams<{
    id: string;
    user_id: string;
  }>();

  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <Suspense fallback={<Spinner />}>
        <StressAssessmentUserResult
          stressAssessmentId={stressAssessmentId}
          userId={Number(userId)}
        />
      </Suspense>
      <div className={styles.bannerWrapper}>
        <Suspense fallback={null}>
          <StressAssessmentScheduleNotificationBanner />
        </Suspense>
      </div>
    </div>
  );
};
